import { SerializedTextNode, TextNode } from 'lexical';
import * as Models from 'models';
import { DraftEntityData } from '../types';
import { getFormateCode, convertTextStyles } from '../utils';

export function createTextNode(
  data: DraftEntityData,
  fonts?: Models.BrandFontsList,
): SerializedTextNode {
  const { text, styles } = data;

  return {
    detail: 0,
    format: getFormateCode(styles),
    mode: 'normal',
    style: convertTextStyles(styles, fonts),
    text,
    type: TextNode.getType(),
    version: 1,
  };
}
